import { type AppType } from "next/app";
import { SpeedInsights } from "@vercel/speed-insights/next";

import "~/styles/globals.css";
import "~/styles/modal-theme.css";
import "~/styles/whop-login.css";

// Everything imported here ships with every page, so this file holds global
// CSS, the portal root, and the Speed Insights beacon only. Pages that call
// API hooks wrap themselves with withApiClient (src/components/app), which
// keeps the tRPC client, react-query, and superjson out of marketing pages.
// The MUI theme mounts around the courses admin editor, the only place that
// renders MUI components, and the toaster lives in the member shell and on
// contact-us, the surfaces that call useToast. Clerk stays out of this file
// for the same reason: ClerkProvider mounts per surface through
// ~/components/auth/ClerkProviderBoundary (statically on /sso-callback and
// /account/sign-in-methods, dynamically inside the dashboard sign-in panel
// chunk), so the @clerk/nextjs client SDK never enters the shared _app chunk.
const MyApp: AppType = ({ Component, pageProps }) => {
  return (
    <>
      <Component {...pageProps} />
      <div id="MODAL_PORTAL"></div>
      <SpeedInsights />
    </>
  );
};

export default MyApp;
